module.exports = __webpack_public_path__ + "img/sld_scb_7_t1_red.7c68b952.svg";